import { Industry, VatType } from "../../utils/enums.utils";
import { CompanyStatus } from "./company-response.interface";

export interface CreateCompanyInterface {
  company_name: string;
  industry: Industry;
  vat_type: VatType;
  product_service: string | null;
  payment_terms: string | null;
  status: CompanyStatus;
  address: string | null;
  tin_number: string | null;
  customer_code: string;
  created_by_id: string | null;
  updated_by_id: string | null;
  attachment_company_logo_id: string | null;
  attachment_org_chart_id: string | null;
}

export interface UpdateCompanyInterface {
  id: string;
  company_name?: string | null;
  industry?: Industry | null;
  vat_type?: VatType | null;
  product_service?: string | null;
  payment_terms?: string | null;
  status?: CompanyStatus | null;
  address?: string | null;
  tin_number?: string | null;
  customer_code?: string | null;
  updated_by_id: string | null;
  attachment_company_logo_id?: string | null;
  attachment_org_chart_id?: string | null;
}
